import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { errorCorrections } from '@global/api/error-correction'
import { ErrorCorrectionRequest, ErrorCorrectionResponse } from '@global/api/error-correction/type'

export const useErrorCorrection = (
  options: UseMutationOptions<
    ErrorCorrectionResponse,
    Error,
    { datasetId: string; request: ErrorCorrectionRequest }
  > = {},
) =>
  useMutation({
    mutationFn: ({ datasetId, request }) => errorCorrections(datasetId, request),
    ...options,
  })
